/**
 * !!! Add Icon components here. If Astro files are imported they !!!
 * !!! cannot transitively include any Node APIs like process     !!!
 *
 * Usage:
 *
 * import Icons from "@components/icons.ts";
 * <Islands.AccordionItem />
 */
import { CaretDownIcon } from "@components/Icons/CaretDownIcon/index.tsx";
import { IconLeft } from "@components/Icons/IconLeft/index.tsx";
import { IconRight } from "@components/Icons/IconRight/index.tsx";
import { PlusRotatingIcon } from "@components/Icons/PlusRotatingIcon/index.tsx";
import { SearchIcon } from "@components/Icons/SearchIcon/index.tsx";
import Icon from "@components/Icons/Icon/index.astro";

const Icons = {
  CaretDownIcon,
  Icon,
  IconLeft,
  IconRight,
  PlusRotatingIcon,
  SearchIcon,
};

export default Icons;
